import { render, staticRenderFns } from "./detailClaims.vue?vue&type=template&id=f5f6b1d6"
import script from "./detailClaims.vue?vue&type=script&lang=js"
export * from "./detailClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports